// Product/asset image paths are derived from filenames (often containing spaces,
// "%", "–", "()" etc.) and stored raw in the DB. They must be percent-encoded
// segment-by-segment (not with encodeURI/encodeURIComponent on the whole string,
// which would either miss "%" or escape the "/" separators) before being used in a URL.
export const encodeImagePath = (path) => {
  if (!path) return "";
  return path.split("/").map(encodeURIComponent).join("/");
};

export const getImageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${process.env.REACT_APP_IMAGE_URL}/${encodeImagePath(path)}`;
};

// Product videos are stored alongside images (same table/paths) and are
// distinguished only by file extension.
export const isVideoPath = (path) => /\.(mp4|webm|mov|m4v)$/i.test(path || "");

// First displayable photo for contexts that can't play video (cards, cart…).
export const firstImagePath = (images) => {
  const first = (images || []).find((img) => !isVideoPath(img?.imagePath));
  return first ? first.imagePath : "";
};
